import {
  CONTEXT_NAMES,
  getOrCreateGlobalStore,
  useStoreWithValidation,
} from '@adsk/alloy-react-context';

export type LocaleStore = {
  locale?: string;
  setLocale: (locale: string) => void;
};

const selector = (state: LocaleStore) => state;

export const useLocaleProviderStore = (locale?: string): LocaleStore =>
  getOrCreateGlobalStore<LocaleStore>(
    (set, get) => ({
      locale,
      setLocale: (newLocale) => {
        if (newLocale !== get().locale) {
          set({ locale: newLocale });
        }
      },
    }),
    CONTEXT_NAMES.LocaleContext,
  )(selector);

export const useLocaleStore = (): LocaleStore =>
  useStoreWithValidation<LocaleStore>(CONTEXT_NAMES.LocaleContext, {
    hook: 'useLocale',
    provider: 'LocaleProvider',
  });
